export type ResourceObject = {
  productionPerHour: number; // Скорость производства в час
  storedResources: number; // Количество ресурсов в хранилище
};

export const calculateBonusTgem = (objects: ResourceObject[]): number => {
  let totalTgem = 0;

  for (const obj of objects) {
    const { productionPerHour, storedResources } = obj;

    if (productionPerHour <= 0 || storedResources <= 0) continue;

    // 1. Считаем 50% от накопленного
    const bonusAmount = storedResources * 0.5;

    // 2. Время, за которое объект произведет bonusAmount
    const minutesEquivalent = (bonusAmount / productionPerHour) * 60;

    // 3. Округление
    let roundedMinutes: number;

    if (minutesEquivalent <= 30) {
      roundedMinutes = 30;
    } else if (minutesEquivalent <= 60) {
      roundedMinutes = 60;
    } else {
      roundedMinutes = Math.ceil(minutesEquivalent / 30) * 30;
    }

    const tgemForObject = (roundedMinutes / 60) * 2.5;
    totalTgem += tgemForObject;
  }

  return Math.ceil(totalTgem);
};
